module.exports = __webpack_public_path__ + "static/media/capri-4.80170065.jpg";